(function ($) {
    $(document).ready(function () {

        // Slick Slider Header
        function slickSliderHeaderFunction() {

            var sliderHeader = $(".header-slider"),
                prevHeader = $(".header .arrows .left"),
                nextHeader = $(".header .arrows .right");

            // Controleer of er meerdere slides zijn
            if (sliderHeader.children().length > 1) {
                sliderHeader.slick({
                    dots: false,
                    arrows: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: false,
                    speed: 500,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    draggable: true,
                    swipe: true, 
                    fade: true, // Fade effect aanzetten voor zachte overgang
                    cssEase: "linear" // Zachte overgang tussen slides
                });

                prevHeader.on("click", function () {
                    sliderHeader.slick("slickPrev");
                });

                nextHeader.on("click", function () {
                    sliderHeader.slick("slickNext");
                });
            }
        }

        // Start Slick Slider met een korte vertraging om ervoor te zorgen dat de DOM klaar is
        setTimeout(slickSliderHeaderFunction, 500);

        // Slick Slider Image / Video
        function slickSliderImageVideoFunction() {

            var sliderImageVideo = $(".image-video-slider"),
                prevImageVideo = $(".image-video .arrows .left"),
                nextImageVideo = $(".image-video .arrows .right");

            // Controleer of er meerdere slides zijn
            if (sliderImageVideo.children().length > 1) {
                sliderImageVideo.slick({
                    dots: false,
                    arrows: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: false,
                    speed: 500,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    draggable: true,
                    swipe: true, 
                    fade: true, // Fade effect aanzetten voor zachte overgang
                    cssEase: "linear" // Zachte overgang tussen slides
                });

                prevImageVideo.on("click", function () {
                    sliderImageVideo.slick("slickPrev");
                });

                nextImageVideo.on("click", function () {
                    sliderImageVideo.slick("slickNext");
                });
            }
        }

        // Start Slick Slider met een korte vertraging om ervoor te zorgen dat de DOM klaar is
        setTimeout(slickSliderImageVideoFunction, 500);

        // Slick Slider Partners
        function slickSliderPartnersFunction() {
            $(".partner-wrapper").each(function () {
                var $wrapper = $(this),
                    $slider = $wrapper.find(".partner-slider"),
                    $prev = $wrapper.find(".arrows .left"),
                    $next = $wrapper.find(".arrows .right"),
                    $arrows = $wrapper.find(".arrows");

                if ($slider.children().length > 0) {
                    var columns = parseInt($slider.data("columns")) || 3;

                    $slider.on("init", function (event, slick) {
                        if (slick.slideCount > slick.options.slidesToShow) {
                            $arrows.removeClass("opacity-0 pointer-events-none");
                        }
                    });

                    $slider.slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        slidesToShow: columns,
                        slidesToScroll: 1,
                        rows: 1,
                        speed: 500,
                        autoplay: false,
                        draggable: true,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: Math.min(2, columns)
                                }
                            },
                            {
                                breakpoint: 640,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });

                    $prev.on("click", function () {
                        $slider.slick("slickPrev");
                    });

                    $next.on("click", function () {
                        $slider.slick("slickNext");
                    });
                }
            });
        }

        // Start Slick Slider met een korte vertraging om ervoor te zorgen dat de DOM klaar is
        setTimeout(slickSliderPartnersFunction, 500);

        // Functie om de body padding-top dynamisch in te stellen
        function adjustBodyPadding() {

            var nav = $(".navigation"); // Selecteer de navigatie
            var screenWidth = $(window).width(); // Haal de schermbreedte op

            if (nav.length) {
                if (screenWidth > 736) { 
                    var navHeight = nav.outerHeight(true); // Meet de hoogte inclusief margins
                    $("body").css("padding-top", navHeight + "px"); // Zet de hoogte als padding-top op de body
                } else {
                    $("body").css("padding-top", "0px"); // Verwijder de padding-top als het scherm ≤ 736px is
                }
            }

        }

        // Voer de functie direct uit bij paginalading
        adjustBodyPadding();

        // Herbereken als het scherm wordt aangepast (bijv. bij resize of scroll)
        $(window).on("resize", function () {
            adjustBodyPadding();
        });

        // Loading indicator
        $(document).ready(function () {
            const $loader = $("#loading-indicator");

            // Controleer of pagina al volledig geladen is
            if (document.readyState === "complete") {
                $loader.fadeOut(500); // Pagina is al geladen, verberg loader direct
                return;
            }

            // Stel een timeout in om de loader pas te tonen bij trage laadtijden
            let loaderTimeout = setTimeout(function () {
                $loader.fadeIn(300); // Loader fade-in bij vertraging
            }, 500); // Toon loader pas als laden langer dan 500ms duurt

            $(window).on("load", function () {
                clearTimeout(loaderTimeout); // Voorkomt tonen als de pagina snel laadt
                $loader.fadeOut(500); // Loader fade-out als alles geladen is
            });
        });

    });

})(jQuery);
